module.exports = __webpack_public_path__ + "static/media/kovan.ad4f5925.svg";